import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

import "./politicaPrivacidade.css";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import Whatsapp from "../../components/whatsapp/whatsapp";
import SEO from "../../components/seo/SEO";
import { getBreadcrumbSchema } from "../../utils/schemas";

function PoliticaPrivacidade() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const breadcrumbs = [
    { name: "Home", url: "https://antoniosaldanhaadvocacia.com.br/" },
    {
      name: "Política de Privacidade",
      url: "https://antoniosaldanhaadvocacia.com.br/politica-de-privacidade",
    },
  ];

  return (
    <div className="container-fluid p-0 pagina-privacidade">
      <SEO
        title="Política de Privacidade | Antonio Saldanha Advocacia"
        description="Política de Privacidade e Proteção de Dados Pessoais (LGPD) do escritório Antonio Saldanha Advocacia."
        canonical="https://antoniosaldanhaadvocacia.com.br/politica-de-privacidade"
        schemaJson={getBreadcrumbSchema(breadcrumbs)}
      />

      <Navbar />

      <main className="py-4">
        <section className="container mt-4">
          <div
            className="max-w-960 mx-auto bg-white p-4 p-md-5 rounded-3 shadow-sm border"
            data-aos="fade-up"
          >
            <span className="badge badge-dourado mb-2">Conformidade LGPD</span>
            <h1 className="titulos-secoes mb-4">
              Política de Privacidade e Proteção de Dados
            </h1>

            <p className="text-secondary lead font-sm mb-4">
              O escritório Antonio Saldanha Advocacia assume o compromisso de
              proteger a privacidade e os dados pessoais de seus clientes e
              visitantes, em conformidade com a Lei Geral de Proteção de Dados
              Pessoais (LGPD - Lei nº 13.709/2018).
            </p>

            <div className="d-flex flex-column gap-4 text-dark font-sm">
              <div>
                <h2 className="fs-5 fw-bold text-dark mb-2 font-corpo">
                  1. Coleta de Dados Pessoais
                </h2>
                <p className="text-muted mb-0">
                  Coletamos informações fornecidas voluntariamente através do
                  nosso formulário de contato e canais de atendimento, tais como
                  nome, e-mail, número de telefone/WhatsApp e mensagem
                  institucional.
                </p>
              </div>

              <div>
                <h2 className="fs-5 fw-bold text-dark mb-2 font-corpo">
                  2. Finalidade do Tratamento
                </h2>
                <p className="text-muted mb-0">
                  Os dados coletados destinam-se exclusivamente a responder às
                  suas solicitações de contato, prestar esclarecimentos
                  jurídicos iniciais e agendar atendimentos.
                </p>
              </div>

              <div>
                <h2 className="fs-5 fw-bold text-dark mb-2 font-corpo">
                  3. Compartilhamento e Segurança
                </h2>
                <p className="text-muted mb-0">
                  O escritório não comercializa ou compartilha seus dados
                  pessoais com terceiros não autorizados. Adotamos medidas de
                  segurança técnicas e administrativas para resguardar suas
                  informações.
                </p>
              </div>

              <div>
                <h2 className="fs-5 fw-bold text-dark mb-2 font-corpo">
                  4. Direitos do Titular
                </h2>
                <p className="text-muted mb-0">
                  Você pode solicitar a qualquer momento a confirmação, acesso,
                  correção ou eliminação dos seus dados pessoais em nossa base,
                  através do e-mail oficial: saldanha.advocacia01@gmail.com.
                </p>
              </div>
            </div>

            <div className="mt-5 pt-3 border-top">
              <Link to="/" className="btn botao-escuro-padrao">
                Voltar para a Página Inicial
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default PoliticaPrivacidade;
